import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';

import { PublishRulesDeadlineModesEnum } from '../enums/publishRulesDeadlineModesEnum';

export const getPublishDeadlineOptions: () => ISelectOption<string>[] = () => [
  {
    id: PublishRulesDeadlineModesEnum.IMMEDIATELY,
    label: 'Сразу',
    value: PublishRulesDeadlineModesEnum.IMMEDIATELY,
  },
  {
    id: PublishRulesDeadlineModesEnum.TOMORROW,
    label: 'На следующий рабочий день',
    value: PublishRulesDeadlineModesEnum.TOMORROW,
  },
];
